import * as types from 'modules/devices/actionTypes';
import type { DeviceOSVersionData, FetchDevicesOSVersionSuccessAction } from 'modules/devices/types';
import { indexValues } from 'modules/devices/utils';
import { createReducer } from 'utils/ReduxUtils';

const initialState: DeviceOSVersionData = {};

const fetchSuccess = (state: DeviceOSVersionData, action: FetchDevicesOSVersionSuccessAction) => {
  const { page, content } = action.payload!;
  const baseState = page.number > 0 ? state : initialState;
  return { ...baseState, ...indexValues(content, 'operatingSystemVersion') };
};

export default createReducer(initialState, {
  [types.FETCH_DEVICES_OS_VERSION_SUCCESS]: fetchSuccess,
});
